import { setRegionId } from '../../../shared/actions/geo';

import type { TReduxStore } from '../../../shared/types/redux';
import type { IAPIParameters } from '@cian/mf-registry-legacy/browser';

export interface ISetRegionIdParameters extends IAPIParameters {
  regionId: number;
}

export function setRegionIdHandler(store: TReduxStore, { regionId }: ISetRegionIdParameters) {
  store.dispatch(setRegionId(regionId));
}
